import React from "react";
import GenericForm from "./GenericForm";
import StringInput from "../formElements/StringInput";
import {useParams} from "react-router-dom";

function ContactForm(props) {

    const {companyName, id} = useParams()

    function parseData(newData) {
        newData.Firma = companyName
        return {...newData}
    }

    const formContent = (data, update) => (
        <>
            <StringInput name={'Meno'} label={'Meno'} value={data.Meno} onChange={update}/>
            <StringInput name={'Telefon'} label={'Telefón'} value={data.Telefon} onChange={update}/>
            <StringInput name={'Mail'} label={'Mail'} value={data.Mail} onChange={update}/>
            <StringInput name={'Oddelenie'} label={'Oddelenie'} value={data.Oddelenie} onChange={update}/>
        </>
    )

    return (
        <GenericForm label={`Kontakt Firmy: ${companyName}`}
                     labelNew={`Pridať Kontakt Firmy: ${companyName}`}
                     baseUrl='/company/contacts/'
                     parseData={parseData}
                     id={id}
                     formContent={formContent}
        />
    )
}

export default ContactForm
